import i18n from "@/i18n";

export interface Template {
  id: string;
  slug: string;
  name: string;
  description?: string;
  type: "email" | "pdf";
  category: string;
  typeLabel: string;
  categoryLabel: string;
  subject?: string;
  subjectSk?: string;
  content: string;
  contentSk?: string;
  variables?: string;
  isSystem: boolean;
  isActive: boolean;
  versionCount?: number;
}

export interface TemplateVersion {
  id: string;
  templateId: string;
  version: number;
  content: string;
  contentSk?: string;
  subject?: string;
  subjectSk?: string;
  changeNote?: string;
  createdBy?: string;
  createdAt: string;
}

export interface VariableInfo {
  key: string;
  label: string;
  description: string;
}

export const CATEGORIES = [
  { value: "newsletter", label: i18n.t("opsAdmin.templates.categories.newsletter") },
  { value: "booking", label: i18n.t("opsAdmin.templates.categories.booking") },
  { value: "payment", label: i18n.t("opsAdmin.templates.categories.payment") },
  { value: "contract", label: i18n.t("opsAdmin.templates.categories.contract") },
  { value: "invoice", label: i18n.t("opsAdmin.templates.categories.invoice") },
  { value: "voucher", label: i18n.t("opsAdmin.templates.categories.voucher") },
  { value: "other", label: i18n.t("opsAdmin.templates.categories.other") },
];

export const TYPES = [
  { value: "email", label: i18n.t("opsAdmin.templates.types.email") },
  { value: "pdf", label: i18n.t("opsAdmin.templates.types.pdf") },
];
